import SidebarLayout from 'components/SidebarLayout'
import WidgetUploadQuiz from 'views/WidgetUploadQuiz'
import { useEffect, useState } from 'react'
import { StyleUtil } from 'utils/StyleUtil'
import { useCompositeAuth } from 'providers/CompositeAuthProvider'
import { useNavigate } from 'react-router-dom'
import Path from 'routes/Path'
import ManageQuizzes from 'views/ManageQuizzes'
import WidgetQuestionGenerator from 'views/WidgetQuestionGenerator'
import { Role } from 'providers/CompositeAuthProvider'

function QuizzeswPage() {
  const navigate = useNavigate()
  const { getRole } = useCompositeAuth()
  const [showUploadWidget, setShowUploadWidget] = useState<boolean>(false)
  const [showQuestionGeneratorWidget, setShowQuestionGeneratorWidget] =
    useState<boolean>(false)

  useEffect(() => {
    if (getRole() === Role.Designer) {
      // redirect to home
      navigate(Path.root.path)
      return
    }
  }, [getRole, navigate])

  return (
    <>
      <SidebarLayout>
        <div
          className={StyleUtil.containerNoScroll}
          style={{
            overflowY: 'auto',
          }}
          data-testid="quizzes-page"
        >
          <p className={StyleUtil.headline} data-testid="quizzes-headline">
            Quiz review tool
          </p>
          <div
            className="flex h-[100%] flex-col pb-10 pt-8"
            data-testid="quizzes-content"
          >
            <ManageQuizzes
              data-testid="manage-quizzes"
              onCreateNew={(
                clientId: string,
                programId: string,
                intakeId: string,
              ) => {
                navigate(
                  Path.quizzes.path +
                    `/create?clientId=${clientId}&programId=${programId}&intakeId=${intakeId}`,
                )
              }}
            />
          </div>
        </div>
      </SidebarLayout>
      {showUploadWidget && (
        <WidgetUploadQuiz
          data-testid="widget-upload-quiz"
          placeholder="Drag spreadsheet here to upload"
          onClose={(_refresh) => {
            setShowUploadWidget(false)
          }}
          onRedirect={(path) => {
            navigate(path)
          }}
        />
      )}
      {showQuestionGeneratorWidget && (
        <WidgetQuestionGenerator
          data-testid="widget-question-generator"
          multiple={true}
          onGenerated={() => {
            setShowQuestionGeneratorWidget(false)
          }}
          onClose={() => {
            setShowQuestionGeneratorWidget(false)
          }}
        />
      )}
    </>
  )
}

export default QuizzeswPage
